<div [class]="'container va-' + animationPosition" [ngClass]="isRecording ? 'recording' : ''">
  <div class="record-button" [ngClass]="disabled ? 'disabled' : ''">
    <flw-icon [name]="iconName" (click)="toggleRecording()" />
  </div>

  @if (isRecording && showVoiceAnimation) {
    <div class="voice-animation">
      @for (_ of [].constructor(9); track _; let i = $index) {
        <div></div>
      }
    </div>
  }
</div>